import { createContext, useContext } from 'react';

export interface IAnalyticsContext {
    hasDecision: boolean;
    sendAnalytics: (eventInfo: string) => void;
    enableTracking: () => void;
    disableTracking: () => void;
}

export const AnalyticsContext = createContext<IAnalyticsContext>({
    hasDecision: false,
    sendAnalytics: () => {},
    enableTracking: () => {},
    disableTracking: () => {},
});

export const useAnalytics = () => useContext(AnalyticsContext);
